import { render, staticRenderFns } from "./food.vue?vue&type=template&id=a8328d68&"
import script from "./food.vue?vue&type=script&lang=js&"
export * from "./food.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8328d68')) {
      api.createRecord('a8328d68', component.options)
    } else {
      api.reload('a8328d68', component.options)
    }
    module.hot.accept("./food.vue?vue&type=template&id=a8328d68&", function () {
      api.rerender('a8328d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/food.vue"
export default component.exports